import { Box, Typography } from "@mui/material";
import React from "react";
import * as styles from "./welcomeStyles";

const Welcome: React.FC = () => {
    return (
        <>
            <Typography sx={styles.sloganText}>
                <Box component="span" sx={styles.highlightNumber}>
                    1887
                </Box>{" "}
                Momente voller Sturm und Glanz.
            </Typography>

            <Typography sx={styles.welcomeText}>
                Willkommen in der Ausstellung
            </Typography>
        </>
    );
};

export default Welcome;
